(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define("Overdrive", ["react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["Overdrive"] = factory(require("react"), require("react-dom"));
	else
		root["Overdrive"] = factory(root["React"], root["ReactDOM"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_106__, __WEBPACK_EXTERNAL_MODULE_107__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition